/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Lightning = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M17.2509 1C17.7982 1 18.1612 1.56733 17.9318 2.06429L15.4219 7.5H20.0009C20.6369 7.5 20.9694 8.231 20.5954 8.70802L20.5265 8.785L6.27647 22.785C5.70831 23.3432 4.77667 22.7478 5.04455 21.9977L8.43586 12.5H4.75086C4.24063 12.5 3.88967 12.0065 4.03181 11.5359L4.06692 11.4422L8.56692 1.44223C8.68803 1.17309 8.95572 1 9.25086 1H17.2509ZM16.0789 2.5H9.73486L5.90986 11H9.50086C9.98493 11 10.3326 11.4476 10.235 11.9044L10.2072 12.0023L7.55586 19.423L18.1659 9H14.2509C13.7377 9 13.3866 8.50137 13.5337 8.02956L13.5699 7.93571L16.0789 2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
